import { render, staticRenderFns } from "./ActivityLogModal.vue?vue&type=template&id=6867c880&"
import script from "./ActivityLogModal.vue?vue&type=script&lang=js&"
export * from "./ActivityLogModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports